import React, { useState } from 'react'
import { Form } from 'react-bootstrap'
import { Link, useLocation } from 'react-router-dom'
import Header from '../Component/Header'
import PageHead from '../Component/pageHead'
import Footer from '../Component/footer'
import { PostAction } from '../Component/PostAction'
import { loginPath, safeReturnPath } from '../utils/sessionAuth'

function ForgotPassword() {
  const location = useLocation()
  const returnUrl = safeReturnPath(new URLSearchParams(location.search).get('returnUrl'))
  const [username, setUsername] = useState('')
  const [saving, setSaving] = useState(false)
  const [message, setMessage] = useState(null)

  const onSubmit = async (e) => {
    e.preventDefault()
    const identifier = String(username || '').trim()
    if (!identifier) {
      setMessage({ error: true, text: 'Please enter your email or mobile number.' })
      return
    }
    setSaving(true)
    setMessage(null)
    try {
      const res = await PostAction('post', { username: identifier }, 'user/forgotPassword')
      const text =
        res?.message ||
        (res?.status === 'success'
          ? 'If an account exists, a temporary password has been sent to the registered email.'
          : 'We could not send a reset email.')
      setMessage({ error: res?.status !== 'success', text })
    } finally {
      setSaving(false)
    }
  }

  return (
    <>
      <Header />
      <PageHead title="Forgot password" />
      <div className="container" style={{ fontSize: 20, minHeight: '615px' }}>
        <div className="card mx-auto" style={{ maxWidth: 520 }}>
          <div className="card-body">
            <p className="mb-3" style={{ fontSize: 16 }}>
              Enter the email or mobile number on your account. We will send a temporary
              password to the registered email. After you log in with it, you will be asked
              to choose a new password.
            </p>
            {message ? (
              <div
                className={`alert ${message.error ? 'alert-danger' : 'alert-success'}`}
                style={{ fontSize: 16 }}
                role="status"
              >
                {message.text}
              </div>
            ) : null}
            <Form onSubmit={onSubmit}>
              <div className="mb-3">
                <label className="form-label" htmlFor="forgot-username">
                  Email or mobile
                </label>
                <input
                  id="forgot-username"
                  className="form-control"
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  autoComplete="username"
                  placeholder="email@example.com or 10-digit mobile"
                />
              </div>
              <div className="text-center">
                <button className="btn btn-primary" type="submit" disabled={saving}>
                  {saving ? 'Sending…' : 'Send temporary password'}
                </button>
                <p className="mt-3 mb-0" style={{ fontSize: 16 }}>
                  <Link to={loginPath(returnUrl)}>Back to Login</Link>
                </p>
              </div>
            </Form>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default ForgotPassword
